import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../hook";
import { RootState } from "../store";
import { criarEstadoBaseDeDashboard, dashboardBaseReducers, DashboardBaseState } from "../dashboardBaseReducers";

export type DreDateSlice = DashboardBaseState & {
  startDate: string;
  endDate: string;
};

const initialState: DreDateSlice = {
  ...criarEstadoBaseDeDashboard(),
  startDate: "",
  endDate: "",
};

export const dreDateSlice = createSlice({
  name: "dreDate",
  initialState,
  reducers: {
    ...dashboardBaseReducers,
    setStartDate: (state, action: PayloadAction<string>) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action: PayloadAction<string>) => {
      state.endDate = action.payload;
    },
    clearExpandedDREItems: (state) => {
      state.expandedDREItems = [];
    },
  },
});

export const {
  setDashboardData,
  setFilters,
  setStartDate,
  setEndDate,
  setLoading,
  setError,
  toggleDREItem,
  setOnboardingData,
  completeOnboarding,
  clearFilters,
  clearExpandedDREItems,
} = dreDateSlice.actions;

// Selectors
export const getDreDateData = (state: RootState) => state.dreDate.data;
export const getDreDateFilters = (state: RootState) => state.dreDate.filters;
export const getDreDateLoading = (state: RootState) => state.dreDate.loading;
export const getDreDateError = (state: RootState) => state.dreDate.error;
export const getExpandedDREItems = (state: RootState) => state.dreDate.expandedDREItems;
export const getOnboardingData = (state: RootState) => state.dreDate.onboarding;
export const getStartDate = (state: RootState) => state.dreDate.startDate;
export const getEndDate = (state: RootState) => state.dreDate.endDate;

// Hooks
export const useDreDateData = () => useAppSelector(getDreDateData);
export const useDreDateFilters = () => useAppSelector(getDreDateFilters);
export const useDreDateLoading = () => useAppSelector(getDreDateLoading);
export const useDreDateError = () => useAppSelector(getDreDateError);
export const useExpandedDREItems = () => useAppSelector(getExpandedDREItems);
export const useOnboardingData = () => useAppSelector(getOnboardingData);
export const useStartDate = () => useAppSelector(getStartDate);
export const useEndDate = () => useAppSelector(getEndDate);

export default dreDateSlice.reducer;
